export const prettifyJson = (json: string | null | undefined) => {
  if (json) {
    try {
      return JSON.stringify(JSON.parse(json), undefined, 2);
    } catch {
      return '[InvalidJson]';
    }
  }
  return '';
};
